import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { ParticipantServerData, ParticipantRole } from '@typings/participant';
import { Show } from '@typings/show';

type InitialState = {
  byId: Record<string, Show>;
  currentShowId: string | null;
  currentRecordedShowId: string | null;
};

export const initialState: InitialState = {
  byId: {},
  currentShowId: null,
  currentRecordedShowId: null,
};

export const showsSlice = createSlice({
  name: 'shows',
  initialState,
  reducers: {
    setShowDataById: (state, action: PayloadAction<Partial<Show>>) => {
      const oldShowData = state.byId[action.payload.id!] || {};
      state.byId[action.payload.id!] = { ...oldShowData, ...action.payload };
    },
    setShowsData: (state, action: PayloadAction<Show[]>) => {
      action.payload.forEach((show) => {
        const previousData = state.byId[show.id] || {};
        state.byId[show.id] = { ...previousData, ...show };
      });
    },
    setCurrentShowId: (state, action: PayloadAction<string | null>) => {
      if (state.currentRecordedShowId) {
        state.currentRecordedShowId = null;
      }
      state.currentShowId = action.payload;
    },
    setCurrentRecordedShowId: (state, action: PayloadAction<string | null>) => {
      if (state.currentShowId) {
        state.currentShowId = null;
      }
      state.currentRecordedShowId = action.payload;
    },
    addParticipantToShow: (
      state,
      action: PayloadAction<ParticipantServerData>,
    ) => {
      const participant = action.payload;
      const show = state.byId[participant.show.id];
      if (participant.role === ParticipantRole.CoHost) {
        return;
      }

      state.byId[show.id] = {
        ...show,
        listenersCount: state.byId[show.id].listenersCount + 1,
      };
    },
    removeParticipantFromShow: (
      state,
      action: PayloadAction<{ id: string; show: { id: string } }>,
    ) => {
      const participant = action.payload;
      const show = state.byId[participant.show.id];
      state.byId[show.id] = {
        ...show,
        listenersCount:
          state.byId[show.id].listenersCount > 0
            ? state.byId[show.id].listenersCount - 1
            : 0,
      };
    },
  },
});

export const { setShowDataById, setShowsData, setCurrentShowId } =
  showsSlice.actions;

export default showsSlice.reducer;
